import * as React from "react";

function RightPaginateArrow(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="0.5" y="0.5" width="29" height="29" rx="3.5" fill="white" />
      <rect x="0.5" y="0.5" width="29" height="29" rx="3.5" stroke="#2AC769" />
      <path
        d="M18.5402 14.29L12.8802 8.64004C12.7873 8.54631 12.6767 8.47191 12.5548 8.42115C12.4329 8.37038 12.3022 8.34424 12.1702 8.34424C12.0382 8.34424 11.9075 8.37038 11.7856 8.42115C11.6638 8.47191 11.5532 8.54631 11.4602 8.64004C11.274 8.8274 11.1694 9.08085 11.1694 9.34504C11.1694 9.60922 11.274 9.86267 11.4602 10.05L16.4102 15.05L11.4602 20C11.274 20.1874 11.1694 20.4409 11.1694 20.705C11.1694 20.9692 11.274 21.2227 11.4602 21.41C11.5528 21.5045 11.6633 21.5797 11.7852 21.6312C11.907 21.6827 12.0379 21.7095 12.1702 21.71C12.3025 21.7095 12.4334 21.6827 12.5553 21.6312C12.6772 21.5797 12.7876 21.5045 12.8802 21.41L18.5402 15.76C18.6417 15.6664 18.7227 15.5527 18.7781 15.4262C18.8336 15.2997 18.8622 15.1631 18.8622 15.025C18.8622 14.8869 18.8336 14.7503 18.7781 14.6238C18.7227 14.4973 18.6417 14.3837 18.5402 14.29Z"
        fill="#2AC769"
      />
    </svg>
  );
}

export default RightPaginateArrow;
